import { useState, useEffect } from "react";
import { X, Share, PlusSquare, Download } from "lucide-react";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem("install_prompt_dismissed") === "true");
  const isMobile = /iphone|ipad|ipod|android/i.test(navigator.userAgent);
  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (dismissed || !isMobile || isStandalone() || (!isIOS && !deferredPrompt)) return null;

  const dismiss = () => {
    localStorage.setItem("install_prompt_dismissed", "true");
    setDismissed(true);
  };

  const install = async () => {
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    dismiss();
  };

  return (
    <div
      className="rounded-2xl mb-6 p-4 flex items-center gap-3 text-white shadow-lg"
      style={{ backgroundColor: "#0F766E" }}
      data-testid="install-prompt-banner"
    >
      <img src="/icon-192.png" alt="" className="w-11 h-11 rounded-xl flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold">Add House of Bloom to your home screen</p>
        {isIOS ? (
          <p className="text-xs opacity-85 mt-0.5 flex items-center gap-1 flex-wrap">
            Tap <Share className="w-3.5 h-3.5 inline" /> Share, then <PlusSquare className="w-3.5 h-3.5 inline" /> "Add to Home Screen"
          </p>
        ) : (
          <p className="text-xs opacity-85 mt-0.5">Your sanctuary, one tap away — no browser bar</p>
        )}
      </div>
      {!isIOS && (
        <button
          onClick={install}
          className="text-xs font-bold px-4 py-2 rounded-full flex-shrink-0"
          style={{ backgroundColor: "#D97706" }}
          data-testid="install-prompt-btn"
        >
          <Download className="w-3.5 h-3.5 inline mr-1" />
          Install
        </button>
      )}
      <button onClick={dismiss} className="p-1.5 rounded-full hover:bg-white/10 flex-shrink-0" aria-label="Dismiss" data-testid="install-prompt-dismiss">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
